import React, { useEffect, useState } from "react";
import { reduxForm, Field, FieldArray } from "redux-form";
import { Grid, Header, Divider, Button, Table } from "semantic-ui-react";
import {
  renderTextField,
  renderRadioField,
  renderTextAreaField,
} from "../formcomponents";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice, ImageUrl } from "../formcomponents/Constants";
import { useNavigate, useParams } from "react-router-dom";
import { userData } from "../store/userData";
import Swal from "sweetalert2";
import ContactFieldArr from "./ContactFieldArr";
import FileUpladArr from "./FileUplaad/FileUpladArr";
const validate = (values) => {
  const errors = {};
  if (!values.visaCategory) {
    errors.workCvisaCategoryategory = "Required";
  }

  return errors;
};

const ComapnyEmpCreate = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const navigate = useNavigate();
  const { id, catId } = useParams();
  const userDetail = userData();
  const [buttonDisable, setbuttonDisable] = useState(false);
  const [imageList, setimageList] = useState([]);
  useEffect(() => {
    if (id !== "null") {
      getWorkList();
      if (userDetail.userRole != 1) {
        setbuttonDisable(true);
      }
    }
  }, []);
  const getWorkList = () => {
    axios
      .post(BaseUrlInvoice + "/accounts/getCompanyEmployeeDetails", {
        companyEmployeeId: id,
      })
      .then((res) => {
        console.log(JSON.stringify(res.data, null, 2));
        const tempData = res.data;
        const filterData = tempData;
        console.log("filterData", filterData);

        initilizeData(filterData);
      })
      .catch((error) => console.log(error));
  };

  const initilizeData = (filterData) => {
    props.initialize({
      companyEmployeeId: filterData.companyEmployeeId,
      categoryId: filterData.categoryId,
      firstName: filterData.firstName,
      middleName: filterData.middleName,
      lastName: filterData.lastName,
      position: filterData.position,
      passportNumber: filterData.passportNumber,
      expiry: filterData.expiry,
      passportWithUs: filterData.passportWithUs,
      passportReturned: filterData.passportReturned,
      remarks: filterData.remarks,
      fileList: [{}],
    });
    setimageList(filterData.fileList);
  };
  const sumbitForm = (values) => {
    const submitObject = {
      ...values,
      // Replace existing contactDetails with tempArr
      userId: userDetail.userId,
      categoryId: catId,
    };

    if (catId == 0) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Category IT is 0 please try again",
      });
    } else {
      console.log(JSON.stringify(submitObject, null, 2));
      axios
        .post(BaseUrlInvoice + "accounts/createCompanyEmployee", submitObject)
        .then((res) => {
          console.log("res", res.data);
          if (res.data.errCode == 200) {
            Swal.fire({
              icon: "success",
              title: "sccess",
              text: "Created",
            });
            navigate(`/list-company-employee/${res.data.categoryId}`);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Create Company Employee
        </Header>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="firstName"
                label="First Name"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="middleName"
                label="Last Name"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="lastName"
                label="Last Name"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="position"
                label="Position"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="passportNumber"
                label="Passport Number"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <label style={{}}>Passport With Us</label>
              <div
                style={{
                  display: "flex",
                  marginTop: "20px",
                }}
              >
                <Field
                  name="passportWithUs" // Replace with your actual field name
                  component={renderRadioField}
                  radioValue={true} // Replace with the value you want when this radio is selected
                  label="Yes" // Replace with the label for the radio
                  // onChange={() => setpassportStatus(true)}
                />{" "}
                <Field
                  name="passportWithUs"
                  component={renderRadioField}
                  radioValue={false}
                  label="No"
                  // onChange={() => setpassportStatus(false)}
                />
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            <Grid.Column>
              <label style={{}}>Passport Returned</label>
              <div
                style={{
                  display: "flex",
                  marginTop: "20px",
                }}
              >
                <Field
                  name="passportReturned" // Replace with your actual field name
                  component={renderRadioField}
                  radioValue={true} // Replace with the value you want when this radio is selected
                  label="Yes" // Replace with the label for the radio
                  // onChange={() => setpassportStatus(true)}
                />{" "}
                <Field
                  name="passportReturned"
                  component={renderRadioField}
                  radioValue={false}
                  label="No"
                  // onChange={() => setpassportStatus(false)}
                />
              </div>
            </Grid.Column>
            <Grid.Column>
              <Field
                name="expiry"
                label="Expiry"
                type="date"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      {/* <Grid.Row>
        <FieldArray name="contactDetails" component={ContactFieldArr} />
      </Grid.Row> */}
      <Grid.Row>
        <FieldArray name="fileList" component={FileUpladArr} />
      </Grid.Row>
      {imageList.length > 0 && (
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>File Name</Table.HeaderCell>
              <Table.HeaderCell>Download Link</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {imageList.map((item, index) => (
              <Table.Row key={index}>
                <Table.Cell collapsing>{item.fileTypeName}</Table.Cell>
                <Table.Cell collapsing>
                  <p
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      window.open(
                        ImageUrl + item.fileName,
                        "_blank",
                        "noopener,noreferrer"
                      )
                    }
                  >
                    Download
                  </p>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}
      <Field name="remarks" component={renderTextAreaField} label="Remarks" />
      <Divider hidden />
      <>
        {" "}
        <Button
          floated="right"
          positive
          disabled={buttonDisable}
          onClick={handleSubmit((values) =>
            sumbitForm({
              ...values,
            })
          )}
        >
          Save
        </Button>
        <Button
          floated="right"
          negative
          disabled={pristine || submitting}
          onClick={reset}
        >
          Cancel
        </Button>{" "}
      </>
    </div>
  );
};

export default reduxForm({
  form: "ComapnyEmpCreate",
  validate,
})(ComapnyEmpCreate);
